/**
 * Employment status is reported by the provider profile API (`/provider/v2/profile`).
 *
 * APIT-622: lockout is a compliance measure that is enforced on the frontend only —
 * the backend keeps serving the account, so the portal is responsible for blocking it.
 * Any status other than `LOCKED_OUT` is treated as "no restriction".
 */
export const LOCKED_OUT_EMPLOYMENT_STATUS = 'LOCKED_OUT';

/**
 * Fallback copy used when the profile response has no `employmentStatusMessage`.
 */
export const DEFAULT_LOCKED_OUT_MESSAGE =
  'Your account access has been suspended. Please contact HR for more information.';

/**
 * Subset of the profile response consumed by the lockout blocker.
 */
export interface EmploymentStatusProfile {
  employmentStatus: string | null;
  employmentStatusMessage: string | null;
}
